import { IUserApiClient, IUserApiClientUrls } from '@/models/api-client/user'
import { UserApiClient } from './UserApiClient'
import { userEndpointConstants } from '@/constants/endpoint'

const urls: IUserApiClientUrls = {
  loginUser: userEndpointConstants.LOGIN_ENDPOINT
}

const userApiClient: IUserApiClient = new UserApiClient(urls)

export default userApiClient
